import React, { useEffect } from "react";
import "./App.css";
import axios from "axios";

// Import components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Weather from "./components/Weather";
import Programs from "./components/Programs";
import Tours from "./components/Tours";
import Review from "./components/Review";
import Footer from "./components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Weather />
      <Programs />
      <Tours />
      <Review />
      <Footer />
    </div>
  );
}

export default App;